<template>
  <div>
    <div
      v-if="key_label && matterWeekHours === 0"
      class="alert alert-warning"
      role="alert"
    >
      {{ $t("teaching.sessionTable.noHoursAssignedPrefix") }}
      {{ $getVisibleNames("teaching.matter", false, "Asignatura") }},
      {{ $t("teaching.sessionTable.noHoursAssignedSuffix") }}
      {{
        $getVisibleNames(
          "manual.matter_program",
          false,
          "Programa de la Asignatura"
        )
      }}.
      <template v-if="sessionPlannigList.length > 0">
        {{ $t("teaching.sessionTable.outOfSpecMessage") }}
      </template>
    </div>
    <table>
      <!-- Con table-layout: fixed los anchos salen de este colgroup y el
           contenido enriquecido (tablas/imágenes en bibliografía) ya no
           puede empujar las columnas. -->
      <colgroup>
        <col class="col-session" />
        <col
          class="col-criteria"
          :class="{ 'col-criteria-wide': hideStudyUnitContents }"
        />
        <col v-if="!hideStudyUnitContents" class="col-contents" />
        <col class="col-strategies" />
        <col class="col-direct-activities" />
        <col class="col-autonomous-activities" />
        <col class="col-bibliography" />
        <col class="col-evaluation" />
        <col v-if="user.is_professor && allows_crud" class="col-observations" />
      </colgroup>
      <thead>
        <tr>
          <!-- <th rowspan="2">SEMANA</th> -->
          <th rowspan="2">{{ $t("teaching.sessionTable.session") }}</th>
          <!-- <th rowspan="2">FECHA</th> -->
          <th rowspan="1" :colspan="hideStudyUnitContents ? 1 : 2">
            {{ $t("teaching.sessionTable.whatWillStudentLearn") }}
          </th>
          <th rowspan="1" colspan="2">
            {{ $t("teaching.sessionTable.howWillTheyLearnIt") }}
          </th>
          <th rowspan="1" colspan="2">
            {{ $t("teaching.sessionTable.howWillTheyPracticeIt") }}
          </th>
          <th rowspan="2" colspan="1">
            {{ $t("teaching.sessionTable.associatedEvaluation") }}
          </th>
          <!-- <th rowspan="2" colspan="1">¿CÓMO RETROALIMENTARÁ SU APRENDIZAJE?</th> -->
          <th
            rowspan="2"
            colspan="1"
            :title="$t('teaching.sessionTable.sessionObservationsTitle')"
            v-if="user.is_professor && allows_crud"
          >
            {{ $t("teaching.sessionTable.obs") }}
          </th>
          <!-- <th v-if="allows_crud" :rowspan="2" title="OBSERVACIONES"></th> -->
        </tr>
        <tr>
          <th>
            {{
              $getVisibleNames(
                "manual.criterio_de_evaluacion",
                true,
                "Criterios de Evaluación"
              )
            }}
            <!-- CRITERIOS DE EVALUACIÓN -->
          </th>
          <th v-if="!hideStudyUnitContents">
            {{
              $getVisibleNames(
                "teaching.studyunitcontent",
                true,
                "Contenidos"
              ).toUpperCase()
            }}
          </th>
          <th>
            {{
              $getVisibleNames(
                "mesh.methodologicalstrategy",
                true,
                "Estrategias Metodológicas"
              ).toUpperCase()
            }}
          </th>
          <th>{{ $t("teaching.sessionTable.classroomActivities") }}</th>
          <th>
            {{
              $getVisibleNames(
                "mesh.autonomousteachingactivity",
                false,
                "Actividad de Trabajo Autónomo"
              ).toUpperCase()
            }}
          </th>
          <th>{{ $t("teaching.sessionTable.basicBibliography") }}</th>
        </tr>
      </thead>
      <draggable
        v-model="sessionPlannigList"
        tag="tbody"
        :disabled="user.is_student || !allows_crud"
      >
        <!-- :study_unit_id="studyUnit.id" -->
        <SessionRow
          v-for="(session_planning, index) in sessionPlannigList"
          :SessionPlanning="session_planning"
          :filter_list="filter_list"
          :index="index"
          :key_label="key_label"
          :section_id="section_id"
          :new_matter_id="matter ? matter.id : 0"
          :matter_id="matter_id || (matter ? matter.matter : null)"
          :total_allowed_sessions="matterWeekHours"
          :allows_crud="allows_crud"
          :key="session_planning.id"
          :BibliographicResources="BibliographicResources"
          :DirectTeachingActivities="DirectTeachingActivities"
          :AutonomousTeachingActivities="AutonomousTeachingActivities"
          :TeachingSupportResource="TeachingSupportResource"
          :EvaluationCriteriaContents="EvaluationCriteriaContents"
          :available_evaluations="available_evaluations"
          :evaluation_link_field="evaluation_link_field"
          :sibling_session_plannings="sessionPlanning"
          @created_session_planning="createdSessionPlanning"
        ></SessionRow>
        <!-- :SumativeEvaluations="SumativeEvaluations" -->
      </draggable>
      <!-- <template v-else>
        <SessionRow
          v-for="(session_planning, index) in sessionPlannigList"
          :SessionPlanning="session_planning"
          :index="index"
          :study_unit_id="studyUnit.id"
          :section_id="section_id"
          :matter_id="matter.id"
          :allows_crud="allows_crud"
          :key="session_planning.id"
          :BibliographicResources="bibliographic_resources"
          :DirectTeachingActivities="DirectTeachingActivities"
          :AutonomousTeachingActivities="AutonomousTeachingActivities"
          :TeachingSupportResource="TeachingSupportResource"
          :SumativeEvaluations="SumativeEvaluations"
        ></SessionRow>
      </template> -->
    </table>
    <div
      v-if="allows_crud && key_label == 'section'"
      style="margin: 10px 1px; text-align: center"
    >
      <b-button
        variant="secondary"
        class="mr-1"
        size="sm"
        @click="$bvModal.show('modal-observations')"
        >{{ $t("teaching.sessionTable.teacherObservations") }}</b-button
      >
      <b-modal
        :title="`${$t('teaching.sessionTable.observationsOfThe')} ${$getVisibleNames(
          'teaching.section',
          false,
          'Sección'
        )}: '${section ? section.name : ''}'`"
        hide-footer
        id="modal-observations"
        size="lg"
      >
        <SectionObservations
          :section_id="section_id"
          :allows_crud="allows_crud"
          @saved="$bvModal.hide('modal-observations')"
        ></SectionObservations>
      </b-modal>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import { generateUniqueId } from "@/utils/utils";

export default {
  name: "SessionTable",
  components: {
    draggable,
    SessionRow: () => import("./SessionRow"),
    SectionObservations: () => import("./SectionObservations"),
  },
  props: {
    // study_unit_id: {
    //   type: Number,
    //   required: true,
    // },
    section_id: {
      type: Number,
    },
    egress_profile_matter_id: {
      type: Number,
      required: true,
    },
    matter_id: {
      type: Number,
    },
    key_label: String,
    filter_list: Array,
    DirectTeachingActivities: Array,
    AutonomousTeachingActivities: Array,
    TeachingSupportResource: Array,
    BibliographicResources: Array,
    EvaluationCriteriaContents: Array,
    available_evaluations: Array,
    evaluation_link_field: String,
    // SumativeEvaluations: Array,
    allows_crud: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      session_plannig_list: [],
      // bibliographic_resources: [],
    };
  },
  computed: {
    ...mapGetters({
      matters: names.MATTERS,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      studyUnits: names.STUDY_UNITS,
      sessionPlannings: names.SESSION_PLANNINGS,
      sections: names.SECTIONS,
      sessionDates: names.SESSION_DATES,
      time_allocations: names.TIME_ALLOCATIONS,
      ep_matter_time_allocations: names.EP_MATTER_TIME_ALLOCATIONS,
      matter_time_allocations: names.MATTER_TIME_ALLOCATIONS,
      user: "getUser",
      institution: "getInstitution",
    }),
    hideStudyUnitContents() {
      return this.$hidesStudyUnitContents(this.institution);
    },
    oldMatter() {
      if (!this.matter) return null;
      return this.matters.find((x) => x.id == this.matter.matter);
    },
    // studyUnit() {
    //   return this.studyUnits.find((x) => x.id == this.study_unit_id);
    // },
    section() {
      return this.sections.find((x) => x.id == this.section_id);
    },
    matter() {
      if (!this.egress_profile_matter_id) return null;
      return this.egress_profiles_matters.find(
        (x) => x.id == this.egress_profile_matter_id
      );
    },
    sessionPlannigList: {
      get() {
        return this.session_plannig_list;
      },
      set(list) {
        for (let index = 0; index < list.length; index++) {
          if (list[index].order != index + 1) {
            try {
              this.patchSessionPlanningOrder(list[index].id, index + 1);
            } catch {
              continue;
            }
          }
          list[index].order = index + 1;
        }
        this.session_plannig_list = list;
      },
    },
    sessionPlanning() {
      const ids_list = this.filter_list.map(
        (object) => object.session_planning
      );
      return this.sessionPlannings.filter((x) => ids_list.includes(x.id));
    },
    // oldMatterWeekHours() {
    //   if (!this.oldMatter) return 0;
    //   return (
    //     this.oldMatter.weeks *
    //     (this.oldMatter.week_theoric_hours +
    //       this.oldMatter.week_lab_hours +
    //       this.oldMatter.week_ground_hours +
    //       this.oldMatter.week_assistantship_hours)
    //   );
    // },
    matterWeekHours() {
      const pedagogical_hours_ids = this.time_allocations
        .filter((x) => x.uses_module_minutes == true)
        .map((x) => x.id);
      let matter_hours = [];
      // La Asignatura Base tiene sus propias horas (MatterTimeAllocation), independientes
      // de la EgressProfileMatter. El tab "Institucional" las usa directo por matter_id,
      // sin depender de que la EgressProfileMatter exista/se haya resuelto.
      if (this.key_label == "matter" && this.matter_id) {
        matter_hours = this.matter_time_allocations.filter(
          (x) =>
            x.matter == this.matter_id &&
            pedagogical_hours_ids.includes(x.time_allocation) &&
            x.counts_towards_credits == true
        );
      } else {
        if (!this.matter) return 0;
        if (this.matter.use_matter_values) {
          matter_hours = this.matter_time_allocations.filter(
            (x) =>
              x.matter == this.matter.matter &&
              pedagogical_hours_ids.includes(x.time_allocation) &&
              x.counts_towards_credits == true
          );
        } else {
          matter_hours = this.ep_matter_time_allocations.filter(
            (x) =>
              x.egress_profile_matter == this.matter.id &&
              pedagogical_hours_ids.includes(x.time_allocation) &&
              x.counts_towards_credits == true
          );
        }
      }
      let hours = 0;
      matter_hours.forEach((hour) => {
        hours += parseFloat(hour.hours);
      });
      return Math.round(parseFloat(hours));
    },
    // sessionDateList() {
    //   let list = this.sessionDates.filter((x) => x.section == this.section_id);
    //   return list.sort(function (a, b) {
    //     if (moment(a.start_date) > moment(b.start_date)) return 1;
    //     if (moment(a.end_date) < moment(b.end_date)) return -1;
    //     return 0;
    //   });
    // },
  },
  methods: {
    createdSessionPlanning(object) {
      const index = this.filter_list.findIndex((x) => x.id == object.id);
      if (index != -1) {
        this.filter_list.splice(index, 1, object);
      } else {
        this.filter_list.push(object);
      }
    },
    patchSessionPlanningOrder(session_planning_id, order) {
      if (isNaN(session_planning_id)) return;
      const payload = {
        session_planning_id: session_planning_id,
        item: {
          order: order,
        },
      };
      this.$store.dispatch(names.PATCH_SESSION_PLANNING, payload);
    },
    updateSessionList() {
      const has_base_matter = this.key_label == "matter" && this.matter_id;
      if (!this.matter && !this.oldMatter && !has_base_matter) return [];
      let sessions = [];
      let list = this.sessionPlanning;
      const session_amount = this.matterWeekHours;
      for (let index = 0; index < session_amount; index++) {
        const element = list.find((x) => x.order == index + 1);
        if (element) {
          sessions.push(element);
        } else {
          sessions.push({
            id: generateUniqueId(),
            order: index + 1,
            date: null,
            // study_unit: this.study_unit_id,
            // section: this.section_id,
            evaluation_criterias_micro: [],
            // performance_indicators: [],
            contents: [],
            evaluation_criteria_macro_contents: [],
            methodological_strategies: [],
            bibliographic_resources: [],
            feedbacks: [],
            direct_teaching_activities: [],
            autonomous_teaching_activities: [],
            teaching_support_resource: [],
            // evaluation: null,
          });
        }
      }
      // Sesiones ya guardadas cuyo order excede las horas pedagógicas configuradas
      // (o todas, si no hay horas configuradas). No se ocultan: se muestran marcadas
      // como fuera de lo especificado en la asignatura (ver total_allowed_sessions).
      const out_of_spec_sessions = list
        .filter((x) => x.order > session_amount)
        .sort((a, b) => a.order - b.order);
      sessions.push(...out_of_spec_sessions);
      this.session_plannig_list = sessions;
    },
    // fetchBibliographicResources() {
    //   if (this.matter && this.bibliographic_resources.length == 0) {
    //     this.$restful
    //       .Get(`/teaching/bibliographic-resource/?matter=${this.matter.matter}`)
    //       .then((response) => {
    //         this.bibliographic_resources = response;
    //       });
    //   }
    // },
    // fetchSessionDates() {
    //   if (!this.section) return;
    // this.section.session_dates.forEach((session_date_id) => {
    //   this.$store.dispatch(names.FETCH_SESSION_DATE, session_date_id);
    // });
    // },
  },
  watch: {
    matter: function () {
      // this.fetchBibliographicResources();
    },
    section() {
      // this.fetchSessionDates();
      this.updateSessionList();
    },
  },
  created() {
    if (this.key_label == "matter") {
      this.$store
        .dispatch(names.FETCH_SESSION_PLANNINGS, { matter_id: this.matter_id })
        .then(() => {
          this.updateSessionList();
        });
    }
    if (this.key_label == "ep_matter") {
      this.$store
        .dispatch(names.FETCH_SESSION_PLANNINGS, {
          egress_profile_matter_id: this.egress_profile_matter_id,
        })
        .then(() => {
          this.updateSessionList();
        });
    }
    if (this.key_label == "section") {
      this.$store
        .dispatch(names.FETCH_SESSION_PLANNINGS, {
          section_id: this.section_id,
        })
        .then(() => {
          this.updateSessionList();
        });
    }
    // this.fetchBibliographicResources();
    // <!-- TODO: Se comento mientras se trabaja en las Evaluaciones. -->
    // this.$store.dispatch(
    //   names.FETCH_EVALUATIONS_BY_STUDY_UNIT,
    //   this.study_unit_id
    // );
    // this.$store.dispatch(names.FETCH_CONTENTS, this.study_unit_id);
    // this.$store.dispatch(names.FETCH_METHODOLOGICAL_STRATEGIES);
    // this.$store.dispatch(names.FETCH_EVALUATION_FEEDBACKS);
  },
  mounted() {
    // this.fetchSessionDates();
  },
};
</script>

<style scoped>
table {
  /* position: relative; */
  width: 100%;
  border: 2px solid var(--kl-table-border);
  font-size: var(--kl-fs-small);
  table-layout: fixed;
}
.col-session {
  width: 3%;
}
.col-criteria {
  width: 16%;
}
.col-contents {
  width: 15%;
}
/* Sin columna de Contenidos (p. ej. PUCV) los criterios absorben su ancho. */
.col-criteria-wide {
  width: 31%;
}
.col-strategies {
  width: 12%;
}
.col-direct-activities {
  width: 12%;
}
.col-autonomous-activities {
  width: 12%;
}
.col-bibliography {
  width: 15%;
}
.col-evaluation {
  width: 11%;
}
.col-observations {
  width: 4%;
}
th {
  vertical-align: middle;
  border: 1px solid var(--kl-table-border);
  /* Header de tabla: azul medio + texto blanco (estándar). */
  background-color: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
  font-weight: var(--kl-fw-bold);
  padding: 0px 5px;
  position: sticky;
  font-size: var(--kl-table-header-fs);
}
.td-header {
  font-size: var(--kl-fs-small);
  color: var(--kl-text-body);
  font-weight: var(--kl-fw-bold);
}
.td-data {
  text-align: justify;
  padding-left: 1rem;
}
td {
  border: 1px solid var(--kl-table-border);
  font-size: var(--kl-fs-caption);
  min-width: 20px;
  background-color: var(--kl-surface);
}
p {
  text-align: justify;
}
</style>